import {
    ADD_VERIFICATION_PROCESS_FAIL,
    ADD_VERIFICATION_PROCESS_REQUEST,
    ADD_VERIFICATION_PROCESS_RESET,
    ADD_VERIFICATION_PROCESS_SUCCESS,
    GET_VERIFICATION_PROCESSES_FAIL,
    GET_VERIFICATION_PROCESSES_REQUEST,
    GET_VERIFICATION_PROCESSES_RESET,
    GET_VERIFICATION_PROCESSES_SUCCESS,
    UPDATE_VERIFICATION_PROCESS_FAIL,
    UPDATE_VERIFICATION_PROCESS_REQUEST,
    UPDATE_VERIFICATION_PROCESS_RESET,
    UPDATE_VERIFICATION_PROCESS_SUCCESS,
    DELETE_VERIFICATION_PROCESS_FAIL,
    DELETE_VERIFICATION_PROCESS_REQUEST,
    DELETE_VERIFICATION_PROCESS_RESET,
    DELETE_VERIFICATION_PROCESS_SUCCESS,
  } from '../constants/verificationProcessConstants';
  
  export const addVerificationProcessReducer = (state = {}, action) => {
    switch (action.type) {
      case ADD_VERIFICATION_PROCESS_REQUEST:
        return { loadingAddVerificationProcess: true };
      case ADD_VERIFICATION_PROCESS_SUCCESS:
        return {
          loadingAddVerificationProcess: false,
          addVerificationProcessData: action.payload,
        };
      case ADD_VERIFICATION_PROCESS_FAIL:
        return {
          loadingAddVerificationProcess: false,
          errorAddVerificationProcess: action.payload,
        };
      case ADD_VERIFICATION_PROCESS_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const getVerificationProcessesReducer = (state = {}, action) => {
    switch (action.type) {
      case GET_VERIFICATION_PROCESSES_REQUEST:
        return { loadingGetVerificationProcesses: true };
      case GET_VERIFICATION_PROCESSES_SUCCESS:
        return { loadingGetVerificationProcesses: false, getVerificationProcessesData: action.payload };
      case GET_VERIFICATION_PROCESSES_FAIL:
        return { loadingGetVerificationProcesses: false, errorGetVerificationProcesses: action.payload };
      case GET_VERIFICATION_PROCESSES_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const updateVerificationProcessReducer = (state = {}, action) => {
    switch (action.type) {
      case UPDATE_VERIFICATION_PROCESS_REQUEST:
        return { loadingUpdateVerificationProcess: true };
      case UPDATE_VERIFICATION_PROCESS_SUCCESS:
        return {
          loadingUpdateVerificationProcess: false,
          updateVerificationProcessData: action.payload,
        };
      case UPDATE_VERIFICATION_PROCESS_FAIL:
        return {
          loadingUpdateVerificationProcess: false,
          errorUpdateVerificationProcess: action.payload,
        };
      case UPDATE_VERIFICATION_PROCESS_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const deleteVerificationProcessReducer = (state = {}, action) => {
    switch (action.type) {
      case DELETE_VERIFICATION_PROCESS_REQUEST:
        return { loadingDeleteVerificationProcess: true };
      case DELETE_VERIFICATION_PROCESS_SUCCESS:
        return {
          loadingDeleteVerificationProcess: false,
          deleteVerificationProcessData: action.payload,
        };
      case DELETE_VERIFICATION_PROCESS_FAIL:
        return {
          loadingDeleteVerificationProcess: false,
          errorDeleteVerificationProcess: action.payload,
        };
      case DELETE_VERIFICATION_PROCESS_RESET:
        return {};
      default:
        return state;
    }
  };